module.exports = __webpack_public_path__ + "static/media/Taming Gaming.2f89389d.jpg";